export default __webpack_public_path__ + "static/media/buster_klein_55.69ed7620.jpg";